module.exports = __webpack_public_path__ + "img/g6.50657ce0.jpeg";